import * as React from "react";
import { Route } from 'react-router-dom';

import ResetPassword from './ResetPassword';

export default [
    <Route exact path="/reset-password" component={ResetPassword} noLayout />,
];